<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_planet_defense', router)
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/planets')
})

const goToPlanets = () => {
  router.push('/planets')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/planet.webm"
  >
    <template #text>
      <p class="pb-2">
        Protecting your planets is crucial for maintaining your empire's security.
      </p>
      <p class="pb-2">
        Your planet has passive defenses and active defenses. Passive defenses reduce damage done to your planet from enemies. Active defenses will be the weapons used to destroy invaders.
      </p>
      <p class="pb-2">
        The first line of defense are your planetary shields <GenericIcon type="shields" />. These are charged by collecting energy <GenericIcon type="energy" /> and stored in your planets energy reserves <GenericIcon type="energy_storage" />. Once these are all depleted, the enemies will wage a ground war against your troops.
      </p>
      <p class="pb-2">
        During the ground war, your planet can sustain extra damage like population loss and damaged buildings.
      </p>
      <p class="pb-2">
        You lose the planet as soon as you run out of troops.
      </p>
      <p class="pb-2">
        You win the battle by destroying all invading ships.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="mb-2">
        <p class="pb-2">
          In the Planets section, click on a planet, and then on the "Defense" tab to see the defensive status of your planet.
        </p>
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        Go to Planets
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Understood!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>